export default __webpack_public_path__ + "static/media/art-red-banner-3.418b664e.jpg";